import React, { Component } from "react";
import PropTypes from "prop-types";
import Autosuggest from "react-autosuggest";
import styled from "styled-components";

export class SearchInput extends Component {
    state = {
        value: "",
        suggestions: []
    };

    getSuggestions(value) {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;
        const isinKeys = Object.keys(this.props.assets);

        if (isinKeys.map(isin => isin.toLowerCase()).find(input => input === inputValue)) {
            return [];
        }

        const assets = [];
        for (const key in this.props.assets) {
            assets.push(this.props.assets[key]);
        }

        const assetMatches = assets
            .filter(fund => fund.toLowerCase().slice(0, inputLength) === inputValue)
            .map(v => {
                return { value: v };
            });

        const isinMatches =
            inputLength > 5
                ? isinKeys
                      .filter(isin => isin.toLowerCase().slice(0, inputLength) === inputValue)
                      .map(isin => {
                          return { value: this.props.assets[isin] };
                      })
                : [];

        const transactionTypeMatches = Object.keys(this.props.transactionTypes)
            .filter(isin => isin.toLowerCase().slice(0, inputLength) === inputValue)
            .map(v => {
                return { value: v };
            });

        const returnMap = [
            { type: "Assets", list: assetMatches.concat(isinMatches).sort() },
            { type: "Transaction Types", list: transactionTypeMatches.sort() }
        ];

        return inputLength === 0 ? [] : returnMap.filter(a => a.list.length > 0);
    }

    getSectionSuggestions(section) {
        return section?.list ?? [];
    }

    getSuggestionValue(suggestion) {
        return suggestion.value;
    }

    renderSectionTitle(section) {
        return <span>{section.type}</span>;
    }

    renderSuggestion(suggestion) {
        return <span>{suggestion.value}</span>;
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });

        let displayTotals = false;
        let searchValue = newValue;
        if (this.props.assets[newValue] !== undefined) {
            searchValue = this.props.assets[newValue];
        } else if (this.props.transactionTypes[newValue] !== undefined) {
            displayTotals = true;
        }
        this.props.onChange(searchValue, displayTotals);
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    render() {
        const { value, suggestions } = this.state;
        const inputProps = {
            placeholder: "search transactions..",
            value,
            onChange: this.onChange
        };

        return (
            <SuggestionsContainer isClientPortal={this.props.isClientPortal}>
                <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={this.renderSuggestion}
                    inputProps={inputProps}
                    multiSection={true}
                    renderSectionTitle={this.renderSectionTitle}
                    getSectionSuggestions={this.getSectionSuggestions}
                />
            </SuggestionsContainer>
        );
    }
}

const SuggestionsContainer = styled.div`
    ${props => (props.isClientPortal ? "justify-content: left;" : "justify-content: right;")}
    display: flex;
    align-items: center;

    .react-autosuggest__input {
        width: 233px;
        height: 30px;
        padding-left: 10px;
        padding-right: 10px;
        font-family: Helvetica, sans-serif;
        font-weight: 300;
        font-size: 12px;
        border: 1px solid #aaa;
        margin-left: 5px;
    }

    .react-autosuggest__container--open .react-autosuggest__input {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    .react-autosuggest__input::-ms-clear {
        display: none;
    }

    .react-autosuggest__suggestions-container {
        display: none;
    }

    .react-autosuggest__container--open .react-autosuggest__suggestions-container {
        display: block;
        position: absolute;
        width: 233px;
        border: 1px solid #aaa;
        background-color: #fff;
        font-family: Helvetica, sans-serif;
        font-weight: 300;
        font-size: 12px;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        z-index: 2;
        margin-left: 5px;
    }

    .react-autosuggest__suggestions-list {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }

    .react-autosuggest__suggestion {
        cursor: pointer;
        padding: 10px 20px;
    }

    .react-autosuggest__suggestion--focused {
        background-color: #ddd;
    }

    .react-autosuggest__section-title {
        padding: 6px;
        font-weight: bold;
    }
`;

SearchInput.propTypes = {
    onChange: PropTypes.func,
    assets: PropTypes.object,
    isClientPortal: PropTypes.bool,
    transactionTypes: PropTypes.object
};
